import { Trans } from '@lingui/macro';
import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import React from 'react';

const AlertSection = ({ closeAlert }: { closeAlert: () => void }) => {
  return (
    <Alert
      severity='error'
      action={
        <IconButton aria-label='close' color='inherit' size='small' onClick={() => closeAlert()}>
          <Close fontSize='inherit' />
        </IconButton>
      }
    >
      <span className='mr-2 text-sm font-semibold'>
        <Trans>Error!</Trans>
      </span>
      <span className='font-thin text-sm'>
        <Trans>Could not setup payment with Stripe. Please try again</Trans>
      </span>
    </Alert>
  );
};

export default AlertSection;
